module.exports = __webpack_public_path__ + "static/media/mod.610b5e74.svg";